/**
 * ExtendSimplifyTrialFECommand — proxy call to ECGrid backend that forwards
 * an Extend Trial action to Simplify.
 */

import type { ICommand, ICommandHandler, IHttpClient } from '@/application/core';

export interface ExtendSimplifyTrialResult {
  subscriptionId: string;
  extendDate: string;
}

export class ExtendSimplifyTrialFECommand implements ICommand<ExtendSimplifyTrialResult> {
  readonly type = 'ExtendSimplifyTrialFECommand' as const;

  constructor(
    public readonly subscriptionId: string,
    public readonly extendDate: string
  ) {}
}

export class ExtendSimplifyTrialFECommandHandler
  implements ICommandHandler<ExtendSimplifyTrialFECommand, ExtendSimplifyTrialResult>
{
  constructor(private readonly httpClient: IHttpClient) {}

  async handle(command: ExtendSimplifyTrialFECommand): Promise<ExtendSimplifyTrialResult> {
    const body = {
      subscription_id: command.subscriptionId,
      extend_date: command.extendDate,
    };

    const response = await this.httpClient.post<any>(
      '/api/v1/simplify-developer-plans/extend-trial',
      body
    );

    if (response?.has_error) {
      throw new Error(response.error_message ?? 'Failed to extend trial');
    }

    return {
      subscriptionId: response?.subscription_id ?? command.subscriptionId,
      extendDate: response?.extend_date ?? command.extendDate,
    };
  }
}
